export default {
	login: process.env.REACT_APP_LOGIN_REDIRECT
};
